import { getImageAsset } from "../../../../helpers/Images";

import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";

import Icon from "../../icons/Icon";



const ExternalLoginIcon = ({iconUrl}:{iconUrl?: string}) => {   
  return (
    <div className={`external-login-icon-wrapper`} aria-hidden="true" data-testid="external-login-icon">
        {iconUrl
            ?   <img 
                    src={getImageAsset(10, iconUrl)} 
                    className={`external-login-icon`} 
                    alt=""
                />
            :   <Icon 
                    className={"external-login-icon default-external-login-icon"} 
                    iconName={IconLibrary.USER_EXTERNAL} 
                    sizeInPx="6"
                    color={"var(--thriveBlue)"}
                />
        }
    </div>
  );
}
export default ExternalLoginIcon